import type { Snapshot } from "../types";

export function liveBankFor(s: Snapshot, pending: number[]): bigint {
  try {
    const bank = BigInt(s.bakery.cookies);
    let accrued = 0n;
    try {
      const cps = BigInt(s.bakery.cps);
      if (cps > 0n) {
        const elapsedSec = Math.max(0, Math.floor((Date.now() - s.serverTime) / 1000));
        if (elapsedSec > 0) accrued = cps * BigInt(elapsedSec);
      }
    } catch {
      accrued = 0n;
    }
    let pendingSum = 0;
    for (let i = 0; i < pending.length; i++) pendingSum += pending[i] ?? 0;
    const pendBig = pendingSum > 0 ? BigInt(Math.floor(pendingSum)) : 0n;
    return bank + accrued + pendBig;
  } catch {
    return 0n;
  }
}
